module.exports = __webpack_public_path__ + "static/img/img-5-2.d6ed9f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-5-2.png
// module id = QZS+
// module chunks = 0